import { getAuth } from "firebase/auth";
import { useEffect, useState } from "react";
import DeleteSchool from "../../../../Controllers/Admin/Schools/DeleteSchool";
import GetAllSchools from "../../../../Controllers/Admin/Schools/GetAllSchools";
import { SetLocalStorage } from "../../../../Controllers/LocalStorage/SetLocalStorage";
import GetUser from "../../../../Controllers/Users/GetUser";

export default function SchoolsListingViewModel() {
  const [AuthUser, setAuthUser] = useState();
  const [SchoolsArray, setSchoolsArray] = useState([]);
  const [loader, setLoader] = useState(true);
  useEffect(() => {
    const fetchData = async () => {
      const user = await getAuth().currentUser;
      if (user) {
        const userData = await GetUser(user.uid);
        setAuthUser(userData);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      if (AuthUser?.uid) {
        const SchoolsData = await GetAllSchools(AuthUser?.uid);

        if (SchoolsData.length) {
          if (!localStorage.getItem("schoolId")) {
            SetLocalStorage("schoolId", SchoolsData[0].id);
          }
          setSchoolsArray(SchoolsData);
        }
        setLoader(false);
      }
    }
    fetchData();
  }, [AuthUser?.uid]);

  // Action Confirmation Start
  const [DeleteDialog, setDeleteDialog] = useState(false);
  const [SchoolID, setSchoolID] = useState("");

  const handleOpenDeleteDialog = (id) => {
    setSchoolID(id);
    setDeleteDialog(true);
  };

  const handleCloseDeleteDialog = async (del) => {
    setDeleteDialog(false);
    if (del === true) {
      await DeleteSchool(SchoolID);
      setDeleteDialog(false);
    }
  };
  // Action Confirmation End

  return [
    SchoolsArray,
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    loader,
  ];
}
